<template>
  <div class="photo-browser-card j-media"
       :class="{'selected': selected,'hovering': hovering, 'found': found, 'found-active': active}"
       draggable="true"
       @dragstart="handleDragStart"
       @dragover.prevent="handleDragOver"
       @contextmenu.prevent="handleContextMenu"
       :data-media-id="photo.id">
    <div class="photo-browser-card__header">
      <div class="d-flex align-items-center justify-content-between">
        <CLink class="mr-2" @click="onSelect">
          <CIcon :name="selected ? 'cipCheck':'cipCircle'"
                 :class="[selected ? 'on':'off','photo-browser-card__icon-check']"
                 size="custom-size"
                 :width="24"/>
        </CLink>
        <div v-if="photo.file_name" :title="photo.file_name" class="photo-browser-card__name">
          {{ photo.file_name }}
        </div>
        <CLink @click="onZoom" class="photo-browser-card__bt-zoom ml-2" v-if="selected">
          <CIcon name="cipResize" size="custom-size" :width="22"/>
        </CLink>
        <div class="ml-2" style="width: 22px" v-else>&nbsp;</div>
      </div>
    </div>
    <div class="photo-browser-card__image" :class="{'selected': selected, 'processed': true}" @click="onImageClick">
      <CImg
          v-if="preLoadable || imageLoaded"
          :src="photo.thumb"
          fluid
          @click="$emit('selected')"
          @load="onImageLoad"
          loading="lazy"
      />
      <CImg v-else :src="require('@/assets/images/event_wizard/photoSearch/ph.png')" />
    </div>
    <div class="photo-browser-card__footer">
      <div class="d-flex align-items-center justify-content-between">
        <CBadge v-for="tag in mediaTags(photo.tags)" :key="tag" shape="pill" color="primary-light no-delete ml-2 mb-1">
          {{ tag }}
        </CBadge>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "GridImage",
  emits: ['selected', 'unselected', 'zoom', 'dragging', 'dragOverMedia', 'contextmenu'],
  props: {
    photo: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: false,
      default: false
    },
    hovering: {
      type: Boolean,
      required: false,
      default: false
    },
    found: {
      type: Boolean,
      required: false,
      default: false
    },
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    selectionMode: {
      type: Boolean,
      required: false,
      default: false
    },
    preLoadable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      isLoading: true,
      imageLoaded: false
    }
  },
  computed: {
    ...mapGetters('photoSearch', ['mediaTags']),
  },
  methods: {
    onImageClick(e) {
      if (this.selectionMode)
        this.onSelect(e)
      else
        this.onZoom(e)
    },
    onZoom(e) {
      e.stopPropagation()
      this.$emit('zoom', this.photo)
    },
    onSelect() {
      if (this.selected)
        this.$emit('unselected', this.photo)
      else
        this.$emit('selected', this.photo)
    },
    handleDragStart(event) {
      this.$emit('dragging', {
        event: event,
        photo: this.photo
      })
    },
    handleDragOver() {
      this.$emit('dragOverMedia', this.photo)
    },
    handleContextMenu(event) {
      this.$emit('contextmenu', {event: event, photo: this.photo})
    },
    onImageLoad() {
      this.imageLoaded = true
    },
  }
}
</script>
